export default __webpack_public_path__ + "static/media/triber-gallery-3.82a6d483.jpg";